module.exports = __webpack_public_path__ + "img/project-big-1.jpg?d269ad5eae4f47fafac3400234bd3f30";